<div
  class="modal-content ridp-modal ridp-modal--error"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="false"
  role="dialog"
  [attr.aria-labelledby]="'my-modal-title'"
>
  <!-- Header -->
  <div class="modal-header">
    <h1 id="my-modal-title" class="modal-title">
      {{ "RIDP_ERROR_HEADER" | globalTranslate }}
    </h1>
  </div>
  <div class="modal-body text-center">
    <div class="error-icon-wrapper">
      <svg
        id="_icons_warning-outline"
        data-name="⚛️ icons/warning-outline"
        xmlns="http://www.w3.org/2000/svg"
        width="60.57"
        height="57.201"
        viewBox="0 0 60.57 57.201"
      >
        <path
          id="Combined_Shape"
          data-name="Combined Shape"
          d="M6.651,57.2A6.656,6.656,0,0,1,.791,47.39L24.423,3.5a6.657,6.657,0,0,1,11.723,0L59.779,47.39a6.656,6.656,0,0,1-5.86,9.811ZM28.329,5.6,4.7,49.493a2.221,2.221,0,0,0,1.954,3.272H53.919a2.219,2.219,0,0,0,1.952-3.272L32.238,5.6a2.218,2.218,0,0,0-3.909,0Zm-.817,39.81a2.773,2.773,0,1,1,2.772,2.774A2.771,2.771,0,0,1,27.512,45.414Zm.556-8.2-.8-16.941a3.015,3.015,0,0,1,2.982-3.126h.093l.053,0a3.013,3.013,0,0,1,2.894,3.152L32.5,37.219a2.219,2.219,0,0,1-4.433,0Z"
          fill="#d7282f"
        />
      </svg>
    </div>
    <div class="content-section">
      <p class="error-text">{{ "RIDP_ERROR_MESSAGE" | globalTranslate }}</p>
    </div>
  </div>
  <div class="modal-footer flex-column">
    <button
      type="button"
      class="btn btn-primary primary-action"
      (click)="onReturnToVerify()"
    >
      {{ "RIDP_ERROR_BTN_RETRY" | globalTranslate }}
    </button>
    @if (!isMobileUser) {
    <div class="alternative-actions pt-4">
      <br />
      <span
        class="apply-text"
        [innerHTML]="'RIDP_PENDING_APPLY_TEXT' | globalTranslate"
      ></span
      ><br />
      <span
        ><a tabindex="0" class="action-link" (click)="onGoToDashboard()">{{
          "RIDP_DASHBOARD_LINK" | globalTranslate
        }}</a></span
      >
    </div>
    } @if (isMobileUser) {
    <div class="modal-body text-center">
      <p class="instruction-text">
        {{ "MOBILE_IDVERIFY_TEXT_02" | globalTranslate }}
      </p>
    </div>
    }
  </div>
</div>